module.exports = __webpack_public_path__ + "media/images/soar/temp/avatar-1-7d0cddc6cba9da20c0a9507cc7b0f3a2.jpg";